import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAssetItemStatusHeaderDetail, setAssetItemStatusHeaderDetail } from "Store/FleetManagement/AssetItemStatusHeaderDetails/AssetItemStatusHeaderDetailsAction";
import { getAssetItemStatusPurchaseDetails } from "Store/FleetManagement/AssetItemStatusPurchaseDetail/AssetItemStatusPurchaseDetailAction";
import { getAssetItemStatusVendorDetail } from "Store/FleetManagement/AssetItemStatusVendorDetail/AssetItemStatusVendorDetailAction";
import { getAssetItemStatusPurchaseOrder } from "Store/FleetManagement/AssetItemStatusPurchaseOrder/AssetItemStatusPurchaseOrderAction";
import { getAssetItemStatusTaskDetail } from "Store/FleetManagement/AssetItemStatusTaskDetails/AssetItemStatusTaskDetailsAction";
import AssetItemStatus from "./AssetItemStatus";

const AssetItemStatusContainer = (props?: any) => {
    const {
        fleetRequestDetailId,
        skipVendorDetail,
        isBulkOrder
    } = props
    const dispatch = useDispatch();
    const [assetItemStatusTemp, setAssetItemStatusTemp] = useState<any>();

    const {
        assetItemStatusHeaderDetail,
        assetItemStatusPurchaseDetails,
        assetItemStatusVendorDetail,
        assetItemStatusPurchaseOrder,
        assetItemStatusTaskDetail,
        assetItemStatusPurchaseDetailsLoadingStates,
        assetItemStatusPurchaseOrderLoadingStates,
        assetItemStatusVendorDetailLoadingStates,
        assetItemStatusTaskDetailLoadingStates
    }: any = useSelector((state: any) => ({
        assetItemStatusHeaderDetail: state.AssetItemStatusHeaderDetailReducers.assetItemStatusHeaderDetail,
        assetItemStatusPurchaseDetails: state.AssetItemStatusPurchaseDetailReducer.assetItemStatusPurchaseDetails,
        assetItemStatusVendorDetail: state.AssetItemStatusVendorDetailReducer.assetItemStatusVendorDetail,
        assetItemStatusPurchaseOrder: state.AssetItemStatusPurchaseOrderReducer.assetItemStatusPurchaseOrder,
        assetItemStatusTaskDetail: state.AssetItemStatusTaskDetailsReducer.assetItemStatusTaskDetail,
        assetItemStatusPurchaseDetailsLoadingStates: state.AssetItemStatusPurchaseDetailReducer.loadingStates,
        assetItemStatusPurchaseOrderLoadingStates: state.AssetItemStatusPurchaseOrderReducer.loadingStates,
        assetItemStatusVendorDetailLoadingStates: state.AssetItemStatusVendorDetailReducer.loadingStates,
        assetItemStatusTaskDetailLoadingStates: state.AssetItemStatusTaskDetailsReducer.loadingStates
    }))

    useEffect(() => {
        dispatch(getAssetItemStatusHeaderDetail(fleetRequestDetailId, assetItemStatusHeaderDetail))
    }, [])

    useEffect(() => {
        let assetItemStatusHeaderDetailTemp = assetItemStatusHeaderDetail?.length ? JSON.parse(JSON.stringify(assetItemStatusHeaderDetail)) : []
        let val = assetItemStatusHeaderDetailTemp?.find((item?: any) => item?.fleetDetailId == fleetRequestDetailId)
        setAssetItemStatusTemp(val);
    }, [fleetRequestDetailId, assetItemStatusHeaderDetail])

    useEffect(() => {
        let assetItemStatusHeaderDetailTemp = assetItemStatusHeaderDetail?.length ? JSON.parse(JSON.stringify(assetItemStatusHeaderDetail)) : []
        if (assetItemStatusHeaderDetailTemp?.length && assetItemStatusPurchaseDetails && assetItemStatusPurchaseDetails?.fleetDetailId == fleetRequestDetailId) {
            assetItemStatusHeaderDetailTemp?.map((item?: any) => {
                if (item?.fleetDetailId == assetItemStatusPurchaseDetails?.fleetDetailId) {
                    item.purchaseDetails = assetItemStatusPurchaseDetails?.response
                    dispatch(setAssetItemStatusHeaderDetail(assetItemStatusHeaderDetailTemp))
                }
            })
        }
    }, [assetItemStatusPurchaseDetails])

    useEffect(() => {
        let assetItemStatusHeaderDetailTemp = assetItemStatusHeaderDetail?.length ? JSON.parse(JSON.stringify(assetItemStatusHeaderDetail)) : []
        if (assetItemStatusHeaderDetailTemp?.length && assetItemStatusVendorDetail && assetItemStatusVendorDetail?.fleetDetailId == fleetRequestDetailId) {
            assetItemStatusHeaderDetailTemp?.map((item?: any) => {
                if (item?.fleetDetailId == assetItemStatusVendorDetail?.fleetDetailId) {
                    item.vendorDetails = assetItemStatusVendorDetail?.response
                    dispatch(setAssetItemStatusHeaderDetail(assetItemStatusHeaderDetailTemp))
                }
            })
        }
    }, [assetItemStatusVendorDetail])

    useEffect(() => {
        let assetItemStatusHeaderDetailTemp = assetItemStatusHeaderDetail?.length ? JSON.parse(JSON.stringify(assetItemStatusHeaderDetail)) : []
        if (assetItemStatusHeaderDetailTemp?.length && assetItemStatusPurchaseOrder && assetItemStatusPurchaseOrder?.fleetDetailId == fleetRequestDetailId) {
            assetItemStatusHeaderDetailTemp?.map((item?: any) => {
                if (item?.fleetDetailId == assetItemStatusPurchaseOrder?.fleetDetailId) {
                    item.purchaseOrder = assetItemStatusPurchaseOrder?.response
                    dispatch(setAssetItemStatusHeaderDetail(assetItemStatusHeaderDetailTemp))
                }
            })
        }
    }, [assetItemStatusPurchaseOrder])

    useEffect(() => {
        let assetItemStatusHeaderDetailTemp = assetItemStatusHeaderDetail?.length ? JSON.parse(JSON.stringify(assetItemStatusHeaderDetail)) : []
        if (assetItemStatusHeaderDetailTemp?.length && assetItemStatusTaskDetail && assetItemStatusTaskDetail?.fleetDetailId == fleetRequestDetailId) {
            assetItemStatusHeaderDetailTemp?.map((item?: any) => {
                if (item?.fleetDetailId == assetItemStatusTaskDetail?.fleetDetailId) {
                    item.taskDetails = assetItemStatusTaskDetail?.response
                    dispatch(setAssetItemStatusHeaderDetail(assetItemStatusHeaderDetailTemp))
                }
            })
        }
    }, [assetItemStatusTaskDetail])

    const onChangeAccordian = (selectedItems: any) => {
        if (selectedItems?.length) {
            const value = selectedItems[selectedItems?.length - 1];
            const result = value?.substring(15, value.length);
            if (value == 'purchaseDetail') {
                dispatch(getAssetItemStatusPurchaseDetails(fleetRequestDetailId))
            } else if (value == 'vendorDetail') {
                dispatch(getAssetItemStatusVendorDetail(fleetRequestDetailId))
            } else if (value == 'purchaseOrder') {
                dispatch(getAssetItemStatusPurchaseOrder(fleetRequestDetailId))
            } else if (value == 'taskdetail') {
                dispatch(getAssetItemStatusTaskDetail({ id: fleetRequestDetailId, isRequisition: true }))
            }
        }
    }

    const getDateAndStatus = (valtype: any, valRequest: any) => {
        if (valtype == "Date") {
            if (valRequest == "TaskDetail") {
                if (assetItemStatusTemp?.hasOwnProperty('taskDetails')) {
                    return (assetItemStatusTemp?.taskDetails?.dateCompleted)
                } else {
                    return (assetItemStatusTemp?.headerDetails?.taskCompletedDate)
                }
            } else if (valRequest == "DealerDetail") {
                if (assetItemStatusTemp?.hasOwnProperty('vendorDetails')) {
                    return (assetItemStatusTemp?.vendorDetails?.dateCompleted)
                } else {
                    return (assetItemStatusTemp?.headerDetails?.dealerDetailCompletedDate)
                }
            } else if (valRequest == "PurchaseOrder") {
                if (assetItemStatusTemp?.hasOwnProperty('purchaseOrder')) {
                    return (assetItemStatusTemp?.purchaseOrder?.dateCompleted)
                } else {
                    return (assetItemStatusTemp?.headerDetails?.purchaseOrderCompletedDate)
                }
            } else if (valRequest == "PurchaseDetail") {
                if (assetItemStatusTemp?.hasOwnProperty('purchaseDetails')) {
                    return (assetItemStatusTemp?.purchaseDetails?.dateCompleted)
                } else {
                    return (assetItemStatusTemp?.headerDetails?.purchaseDetailCompletedDate)
                }
            }
        } else if (valtype == "Status") {
            if (valRequest == "TaskDetail") {
                if (assetItemStatusTemp?.hasOwnProperty('taskDetails')) {
                    return (assetItemStatusTemp?.taskDetails?.status)
                } else {
                    return (assetItemStatusTemp?.headerDetails?.taskStatus)
                }
            } else if (valRequest == "DealerDetail") {
                if (assetItemStatusTemp?.hasOwnProperty('vendorDetails')) {
                    return (assetItemStatusTemp?.vendorDetails?.status)
                } else {
                    return (assetItemStatusTemp?.headerDetails?.dealerDetailStatus)
                }
            } else if (valRequest == "PurchaseOrder") {
                if (assetItemStatusTemp?.hasOwnProperty('purchaseOrder')) {
                    return (assetItemStatusTemp?.purchaseOrder?.status)
                } else {
                    return (assetItemStatusTemp?.headerDetails?.purchaseOrderStatus)
                }
            } else if (valRequest == "PurchaseDetail") {
                if (assetItemStatusTemp?.hasOwnProperty('purchaseDetails')) {
                    return (assetItemStatusTemp?.purchaseDetails?.status)
                } else {
                    return (assetItemStatusTemp?.headerDetails?.purchaseDetailStatus)
                }
            }
        }
    }

    const isAssetItemStatusPurchaseDetailsCalled = (fleetDetailId: any) => {
        return assetItemStatusPurchaseDetailsLoadingStates[fleetDetailId]?.isLoading || false;
    };

    const isAssetItemStatusPurchaseOrderCalled = (fleetDetailId: any) => {
        return assetItemStatusPurchaseOrderLoadingStates[fleetDetailId]?.isLoading || false;
    };

    const isAssetItemStatusVendorDetailCalled = (fleetDetailId: any) => {
        return assetItemStatusVendorDetailLoadingStates[fleetDetailId]?.isLoading || false;
    };

    const isAssetItemStatusTaskDetailCalled = (fleetDetailId: any) => {
        return assetItemStatusTaskDetailLoadingStates[fleetDetailId]?.isLoading || false;
    };

    return (
        <AssetItemStatus
            fleetRequestDetailId={fleetRequestDetailId}
            assetItemStatusHeaderDetail={assetItemStatusHeaderDetail}
            onChangeAccordian={onChangeAccordian}
            assetItemStatusTemp={assetItemStatusTemp}
            skipVendorDetail = {skipVendorDetail}
            isBulkOrder = {isBulkOrder}
            getDateAndStatus = {getDateAndStatus}
            isAssetItemStatusPurchaseDetailsCalled = {isAssetItemStatusPurchaseDetailsCalled}
            isAssetItemStatusPurchaseOrderCalled = {isAssetItemStatusPurchaseOrderCalled}
            isAssetItemStatusVendorDetailCalled = {isAssetItemStatusVendorDetailCalled}
            isAssetItemStatusTaskDetailCalled = {isAssetItemStatusTaskDetailCalled}
        />
    )
}

export default AssetItemStatusContainer;